module.exports = __webpack_public_path__ + "img/proxy-customer.2f8e91b9.svg";